import { CatalogTextWithOrderComponent } from './catalog-text-with-order.component';
import { GetOrderListResponse } from './api-services/get-order-list.service';

/**
 * 企画回テキストボックスManageクラス
 *
 * @export CatalogTextWithOrderModel
 * @class CatalogTextWithOrderModel
 */
export class CatalogTextWithOrderModel {
  public orderList: GetOrderListResponse = [];

  /** テキストボックスインスタンス */
  public catalogIdTextInput: CatalogTextWithOrderComponent;
  /** コードリスト取得完了 */
  public completeUpdateOrderCodeList: boolean = <boolean>false;

  /**
   * 発注コードリストアップデート
   *
   * @param serverData:サーバから取得された<Data>タグ
   */
  public updateOrderList(serverData: GetOrderListResponse) {
    if (serverData == null) {
      this.orderList = [];
      return;
    }
    this.orderList = serverData;

    this.completeUpdateOrderCodeList = true;
    this.catalogIdTextInput.changeCatalogIdHandler();
  }

  get selectedOrderCode() {
    if (!this.catalogIdTextInput.text) return '';
    return this.orderList.find(
      _ => this.catalogIdTextInput.text === _.CatalogID
    )?.OrderCode;
  }
}
